import React from 'react';
import s from './SignalTranslation.module.scss';
import { FormattedMessage } from 'react-intl';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Cookies from 'js-cookie';
import { SIGNALTRANSLATION_FINALIZED, SIGNALTRANSLATION_UPLOADED } from '../../constants/index';
import { WidgetVisibility, IsWidgetAccessible } from '../../utils/widgetManager';

const SignalTranslationFinalize = ({
  signalTranslationManager,
  saveSignalTranslation,
  unitSerialNumber,
  updateUnitShadow,
  userProfileWidgets,
  selectedUnit
}) => {
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;

  const finalizeHandler = () => {
    let saveData = signalTranslationManager.SelectedSignalTranslation;
    saveData.IsFinalized = true;
    saveData.Status = SIGNALTRANSLATION_FINALIZED;
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;
    saveSignalTranslation(saveData, unitSerialNumber, false, 'SIGNALTRANSLATION_FINALIZE');
  };

  const uploadHandler = () => {
    let saveData = signalTranslationManager.SelectedSignalTranslation;
    saveData.IsUploaded = true;
    saveData.Status = SIGNALTRANSLATION_UPLOADED;
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;
    //saveSignalTranslation(saveData, unitSerialNumber);
    let payLoadData = {
      uploadUnitSignalTranslations: true,
      modelId: selectedUnit.ModelId,
      modelVariantId: saveData.ModelVariantId,
      unitId: saveData.UnitId,
      unitSerialNumber: unitSerialNumber,
      updatedBy: saveData.UpdatedBy
    };
    updateUnitShadow(saveData, unitSerialNumber, payLoadData, true);
  };

  const isFinalizedDisabled = signalTranslationManager.SelectedSignalTranslation.IsFinalized;
  const isUploadDisabled = !signalTranslationManager.SelectedSignalTranslation.IsFinalized || signalTranslationManager.SelectedSignalTranslation.IsUploaded;

  return (
    <div className={s.signalTranslation}>
      <div className={s.contentWrapper}>
        {(IsWidgetAccessible(userProfileWidgets, 'SIGNALTRANSLATION_FINALIZE') ||
          IsWidgetAccessible(userProfileWidgets, 'UPLOAD_UNIT_SHADOW')) && (
          <div className={s.signalTranslationFinalize}>
            <Row className={s.breakrow}>
              <Col sm={12}>
                <FormattedMessage id="signalTranslation.finalizeNote" defaultMessage="Please finalize before uploading the signalTranslation" />
              </Col>
            </Row>
            <Row className={s.breakrow}>
              <Col sm={12}>
                <Button
                  style={WidgetVisibility(userProfileWidgets, `SIGNALTRANSLATION_FINALIZE`)}
                  className={s.finalizeButton + ' ' + (!isFinalizedDisabled ? '' : s.buttonDisable)}
                  onClick={finalizeHandler}
                  disabled={isFinalizedDisabled}
                  data-unittest="finalizeButton"
                >
                  <FormattedMessage id="signalTranslation.finalize" defaultMessage="FINALIZE" />
                </Button>
                <Button
                  className={s.finalizeButton + ' ' + (!isUploadDisabled ? '' : s.buttonDisable)}
                  onClick={uploadHandler}
                  disabled={isUploadDisabled}
                  data-unittest="uploadButton"
                  style={WidgetVisibility(userProfileWidgets, `UPLOAD_UNIT_SHADOW`)}
                >
                  <FormattedMessage id="signalTranslation.upload" defaultMessage="UPLOAD" />
                </Button>
              </Col>
            </Row>
          </div>
        )}
      </div>
    </div>
  );
};

export default SignalTranslationFinalize;
